if (!window.__ndwHomeJS) {
window.__ndwHomeJS = true;
// Auto-rotating hero: the scenes (Recover -> Sleep -> Hydrate) cross-fade on a
// timer. The current product + title sink out of the hexagon as the next rises in
// from below. The page scrolls normally — no scroll hijack. Autoplay pauses while
// the pointer rests over the intro/CTA block (so a click isn't interrupted) and
// while the tab is hidden or reduced-motion is requested.
(function () {
  const products = Array.from(document.querySelectorAll(".hero__product"));
  const titles = Array.from(document.querySelectorAll(".hero__title"));
  if (products.length === 0) return;

  // The page gradient lives on <main>; each scene swaps its accent via the
  // [data-hero-scene] index (see body.gradient main rules in the CSS).
  const mainEl =
    document.querySelector("body.gradient main") ||
    document.querySelector("main");

  // One intro block per scene; they slide like the products (parked below the
  // clip box, the active one at rest).
  const intros = Array.from(document.querySelectorAll(".hero__intro"));
  const introClip = document.querySelector(".hero__intro-clip");
  const INTRO_BELOW = 100; // % of its own height parked below (clipped within itself)

  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  // In the theme editor keep the hero still on scene 0 so it's easy to edit.
  const designMode = window.Shopify && window.Shopify.designMode;

  const N = products.length;

  const AUTOPLAY_MS = 5000; // each scene rests this long before advancing

  // Title positions, in % of its own (clipped) height:
  //   ABOVE = parked above the clip box, ready to drop in from the top
  //   BELOW = pushed below the clip box after sinking out
  const TITLE_ABOVE = -60; // short drop from near the hexagon's top (fades in)
  const TITLE_BELOW = 130;
  const PRODUCT_SHIFT = 420; // px a product sits below before rising in

  // Uniform timeline (ms from the start of a transition):
  //   1) the whole old scene (title + product + intro) exits together -> starts at 0
  //   2) the whole new scene enters together, once the old is ~80% gone
  // Every element shares MOVE_MS, so within each phase they move and settle in sync.
  const MOVE_MS = 1000; // one element's slide duration (matches --scene-dur in CSS)
  const INTRO_MOVE = 650; // intro slide duration (matches --intro-dur in CSS)
  const T_ENTER = Math.round(MOVE_MS * 0.8); // new scene enters at 80% of the old one's exit
  const LOCK_MS = T_ENTER + MOVE_MS; // lock until the new scene finishes sliding in
  const EXIT_STAGGER = 100; // on exit, product + intro start 100ms after the title but finish with it

  // First-load entry: title drops from the top, then the product and intro rise
  // from below in a quick cascade.
  // On first load all three (title, product, intro) start together and share
  // MOVE_MS, so they also finish together.
  const LOAD_DONE = MOVE_MS;

  let current = 0;
  let animating = false;
  let paused = false; // pointer resting over the intro/CTA block
  let timer = null;

  function stopTimer() {
    if (timer) {
      window.clearTimeout(timer);
      timer = null;
    }
  }

  // Arm the next auto-advance unless paused, in the editor, reduced-motion, the
  // tab is hidden, or there's nothing to rotate.
  function scheduleNext() {
    stopTimer();
    if (reduceMotion || designMode || paused || N < 2 || document.hidden) return;
    timer = window.setTimeout(function () {
      goTo(current + 1);
    }, AUTOPLAY_MS);
  }

  function place(el, y, opacity, unit) {
    if (!el) return;
    el.style.transform =
      "translateX(-50%) translateY(" + y + (unit || "px") + ")";
    el.style.opacity = opacity;
  }

  function placeProduct(i, active) {
    place(products[i], active ? 0 : PRODUCT_SHIFT, active ? 1 : 0);
  }

  // Park a product with no animation (so the first-load park doesn't animate
  // from the CSS default before the entry runs).
  function snapProduct(i, active) {
    const el = products[i];
    if (!el) return;
    el.style.transition = "none";
    el.style.transform =
      "translateX(-50%) translateY(" + (active ? 0 : PRODUCT_SHIFT) + "px)";
    el.style.opacity = active ? 1 : 0;
    void el.offsetWidth; // force reflow so the next change animates
    el.style.transition = "";
  }

  // Intro slide: active sits at rest, others are pushed a full height below.
  function placeIntro(i, active) {
    const el = intros[i];
    if (!el) return;
    el.style.transform = active
      ? "translateY(0)"
      : "translateY(" + INTRO_BELOW + "%)";
    el.setAttribute("aria-hidden", active ? "false" : "true");
  }

  function snapIntro(i, active) {
    const el = intros[i];
    if (!el) return;
    el.style.transition = "none";
    el.style.transform = active
      ? "translateY(0)"
      : "translateY(" + INTRO_BELOW + "%)";
    el.setAttribute("aria-hidden", active ? "false" : "true");
    void el.offsetWidth; // force reflow so the next change animates
    el.style.transition = "";
  }

  // Short drop from near the top: the title fades in as it slides into place.
  function placeTitle(i, yPercent, opacity) {
    place(titles[i], yPercent, opacity, "%");
  }

  // Jump a title to a position with no animation (used to reset an exited title
  // back above the clip box without it sliding up through the visible area).
  function snapTitle(i, yPercent, opacity) {
    const el = titles[i];
    if (!el) return;
    el.style.transition = "none";
    el.style.transform = "translateX(-50%) translateY(" + yPercent + "%)";
    el.style.opacity = opacity;
    void el.offsetWidth; // force reflow so the next change animates
    el.style.transition = "";
  }

  // Park every scene hidden, then play the first-load entry for scene 0.
  function init() {
    // Park everything hidden with no animation: titles above, products + intros
    // below. The background for scene 0 is shown immediately.
    titles.forEach((_, i) => snapTitle(i, TITLE_ABOVE, 0));
    products.forEach((_, i) => snapProduct(i, false));
    intros.forEach((_, i) => snapIntro(i, false));
    if (mainEl) mainEl.setAttribute("data-hero-scene", "0");

    // First-load entry: animate scene 0 in (title from the top, product + intro
    // from below) after the parked state has painted, then start the autoplay.
    animating = true;
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        // All three start together in the same frame and share the title's
        // duration (MOVE_MS), so they also finish together. Intro's default is
        // the shorter --intro-dur, so override it for this entry.
        if (products[0]) products[0].style.transitionDuration = MOVE_MS + "ms";
        if (intros[0]) intros[0].style.transitionDuration = MOVE_MS + "ms";
        placeTitle(0, 0, 1); // text drops in from the top
        placeProduct(0, true); // product rises from below
        placeIntro(0, true); // intro rises from below
        window.setTimeout(function () {
          // restore CSS-default durations so scene swaps animate normally
          if (products[0]) products[0].style.transitionDuration = "";
          if (intros[0]) intros[0].style.transitionDuration = "";
          animating = false;
          scheduleNext();
        }, LOAD_DONE);
      });
    });
  }

  // Advance to a target scene (wraps around). Same choreography as before: the
  // previous scene (title + product + intro) exits together, the new one enters
  // once the old is ~80% gone. Idle titles rest above the clip box (TITLE_ABOVE)
  // so the incoming title can always slide down into place from the top.
  function goTo(target) {
    if (animating || N < 2) return;
    target = ((target % N) + N) % N;
    if (target === current) return;

    animating = true;
    const previous = current;
    current = target;

    // 1) Previous scene exits: title sinks down at 0; product + intro follow
    //    EXIT_STAGGER later with a shortened slide so all three finish dropping
    //    at the same time.
    placeTitle(previous, TITLE_BELOW, 0);
    window.setTimeout(function () {
      if (products[previous]) products[previous].style.transitionDuration = (MOVE_MS - EXIT_STAGGER) + "ms";
      if (intros[previous]) intros[previous].style.transitionDuration = (MOVE_MS - EXIT_STAGGER) + "ms";
      placeProduct(previous, false);
      placeIntro(previous, false);
    }, EXIT_STAGGER);

    // 2) The whole new scene enters together once the old is ~80% gone; the
    //    background cross-fades so the new scene's color is already there.
    window.setTimeout(function () {
      if (mainEl) mainEl.setAttribute("data-hero-scene", String(current));
      if (intros[current]) intros[current].style.transitionDuration = MOVE_MS + "ms";
      placeTitle(current, 0, 1);
      placeProduct(current, true);
      placeIntro(current, true);
    }, T_ENTER);

    // Settle: reset the exited title above the box, restore durations, re-arm.
    window.setTimeout(function () {
      snapTitle(previous, TITLE_ABOVE, 0);
      if (products[previous]) products[previous].style.transitionDuration = "";
      if (intros[previous]) intros[previous].style.transitionDuration = "";
      if (intros[current]) intros[current].style.transitionDuration = "";
      animating = false;
      scheduleNext();
    }, LOCK_MS);
  }

  init();

  // Pause autoplay while the pointer rests over the intro/CTA block, so a scene
  // never changes while the user is reaching for the button. Touch has no
  // lingering hover, so it's ignored here (a tap on the CTA just works).
  if (introClip) {
    introClip.addEventListener("pointerenter", function (e) {
      if (e.pointerType === "touch") return;
      paused = true;
      stopTimer();
    });
    introClip.addEventListener("pointerleave", function (e) {
      if (e.pointerType === "touch") return;
      paused = false;
      scheduleNext();
    });
  }

  // Discreet prev/next arrows: step one scene and restart the autoplay clock so
  // the hero doesn't immediately jump again right after a manual click.
  document.querySelectorAll("[data-hero-nav]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      if (N < 2) return;
      const dir = btn.getAttribute("data-hero-nav") === "prev" ? -1 : 1;
      goTo(current + dir);
      scheduleNext();
    });
  });

  // Don't advance in a hidden tab; re-arm when it becomes visible again.
  document.addEventListener("visibilitychange", scheduleNext);
})();

// Shop mega-menu. Hover is driven from JS (not pure CSS :hover) with a short
// close delay so the cursor can cross the gap between the "Shop" trigger and the
// panel without the menu snapping shut. Also supports click/tap (touch),
// keyboard focus, Esc, and outside-click dismissal, keeping aria-expanded synced.
(function () {
  const nav = document.getElementById("siteNav");
  const item = document.querySelector(".site-nav__item--has-menu");
  const toggle = document.querySelector(".site-nav__link--toggle");
  const menu = document.getElementById("shopMenu");
  if (!item || !toggle || !menu) return;

  const CLOSE_DELAY = 150; // ms grace period to bridge the trigger→panel gap
  let closeTimer = null;

  function open() {
    window.clearTimeout(closeTimer);
    menu.classList.add("is-open");
    if (nav) nav.classList.add("is-menu-open");
    toggle.setAttribute("aria-expanded", "true");
  }

  function close() {
    window.clearTimeout(closeTimer);
    menu.classList.remove("is-open");
    if (nav) nav.classList.remove("is-menu-open");
    toggle.setAttribute("aria-expanded", "false");
  }

  function scheduleClose() {
    window.clearTimeout(closeTimer);
    closeTimer = window.setTimeout(close, CLOSE_DELAY);
  }

  // Pointer: leaving the whole item (trigger + panel) starts the delayed close;
  // re-entering anywhere within it cancels.
  item.addEventListener("mouseenter", open);
  item.addEventListener("mouseleave", scheduleClose);

  // Click/tap toggles (covers touch devices where hover doesn't apply).
  toggle.addEventListener("click", function (e) {
    e.preventDefault();
    if (menu.classList.contains("is-open")) close();
    else open();
  });

  // Keyboard: close when focus leaves the menu entirely.
  item.addEventListener("focusout", function (e) {
    if (!item.contains(e.relatedTarget)) close();
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && menu.classList.contains("is-open")) {
      close();
      toggle.focus();
    }
  });

  document.addEventListener("click", function (e) {
    if (!menu.classList.contains("is-open")) return;
    if (!item.contains(e.target)) close();
  });

  // Left categories: clicking one makes it the active (dark) row. The product
  // cards stay the same for now — only the highlighted category changes.
  const cats = Array.prototype.slice.call(
    menu.querySelectorAll(".mega-menu__cat"),
  );
  cats.forEach(function (cat) {
    cat.addEventListener("click", function (e) {
      e.preventDefault();
      cats.forEach(function (c) {
        const isActive = c === cat;
        c.classList.toggle("mega-menu__cat--active", isActive);
        const arrow = c.querySelector(".mega-menu__cat-arrow");
        if (arrow) {
          arrow.src = isActive
            ? "images/menu-chevron-active.svg"
            : "images/menu-chevron.svg";
        }
      });
    });
  });
})();

// Overlay header: solid white + shadow once the page is scrolled away from the
// top. The hero pins and keeps scrollY at 0 through its scenes, so this only
// kicks in after the hero releases and the user scrolls on.
(function () {
  const nav = document.getElementById("siteNav");
  if (!nav || !nav.classList.contains("site-nav--overlay")) return;
  // A campaign hero can pin the header solid from the top; leave it alone.
  if (nav.hasAttribute("data-nav-solid-locked")) return;

  const SCROLL_THRESHOLD = 8; // px past the top before going solid

  function sync() {
    nav.classList.toggle("is-scrolled", window.scrollY > SCROLL_THRESHOLD);
  }

  sync();
  window.addEventListener("scroll", sync, { passive: true });
})();

// Retailers strip: a scroll-linked horizontal reveal. At rest the strip is
// full-width with the "Find Us In Store" pill half off the right edge. As the
// section scrolls up into view the track slides left just far enough to bring
// the pill fully inside the container, where it settles. Scrolling back up
// reverses it to the starting position.
(function () {
  const section = document.querySelector(".retailers");
  // Slide the whole reveal block (logo track + CTA) so the CTA pill glides in.
  // The track itself is left to the mobile marquee.
  const track = section && section.querySelector(".retailers__reveal");
  const cta = document.getElementById("findUsCta");
  if (!section || !track || !cta) return;
  // In scroll mode the row is a marquee at every width and the CTA sits below
  // it, so there is nothing to slide.
  if (section.classList.contains("retailers--scroll")) return;

  const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  // Container gutter so the pill lands aligned to the 1200px container's right
  // edge when settled. The nav bar is that same centred container, so its left
  // offset is the gutter; fall back to the matching formula if it's absent.
  const navBar = document.querySelector(".site-nav__bar");
  function gutter() {
    if (navBar) {
      // On mobile the bar spans full width with inner padding (left edge at 0),
      // so add its padding to keep a real gutter instead of collapsing to 0.
      const rect = navBar.getBoundingClientRect();
      const pad = parseFloat(getComputedStyle(navBar).paddingLeft) || 0;
      return rect.left + pad;
    }
    const containerW = Math.min(1200, window.innerWidth - 48);
    return (window.innerWidth - containerW) / 2;
  }

  let restX = 0; // transform at progress 0 — pill half off the right edge
  let endX = 0; // transform at progress 1 — pill inside the container
  let ticking = false;

  function measure() {
    const vw = window.innerWidth;
    const trackW = track.scrollWidth;
    const ctaW = cta.offsetWidth;
    // At translateX = X the track's right edge (= the pill's right edge) sits at
    // trackW + X. Park it half a pill-width past the viewport at rest, and at
    // (viewport - gutter) once settled.
    // Start with the first logo (Walmart) visible at the left gutter, then the
    // track slides left as you scroll so the CTA pill settles on the right.
    // +20px so the first logo clears the edge shadow and reads in full at rest.
    restX = gutter() + 60;
    endX = vw - gutter() - trackW;
  }

  function progress() {
    const rect = section.getBoundingClientRect();
    const vh = window.innerHeight;
    // 0 when the section's top is at the viewport bottom; 1 once it has risen to
    // ~40% from the top. Clamped, so it holds at 1 after scrolling past and
    // returns to 0 on the way back up.
    const DELAY = 200; // hold still for the first ~200px of scroll before moving
    const start = vh;
    const end = vh * 0.4;
    return Math.min(1, Math.max(0, (start - rect.top - DELAY) / (start - end)));
  }

  function render() {
    ticking = false;
    // Below 900px the track runs as an infinite marquee (CSS animation), so the
    // scroll-reveal must not touch its transform — clear it and bail.
    if (window.innerWidth <= 900) {
      track.style.transform = "";
      return;
    }
    const x = reduce ? endX : restX + (endX - restX) * progress();
    track.style.transform = "translateX(" + x + "px)";
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(render);
  }

  function onResize() {
    measure();
    onScroll();
  }

  measure();
  render();
  window.addEventListener("scroll", onScroll, { passive: true });
  window.addEventListener("resize", onResize, { passive: true });
})();

// Seamless infinite marquee. For each `.js-marquee`, the canonical track holds
// one set of items; this clones that set until one "half" is at least as wide as
// the viewport, then duplicates the half so the CSS `translateX(-50%)` loop wraps
// with no gap and no jump on any screen width. Duration is derived from the half
// width so the scroll speed (px/sec) stays constant regardless of copy count.
(function () {
  const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function initMarquee(marquee) {
    const track = marquee.querySelector("[data-marquee-track]");
    if (!track) return;

    const baseSets = Array.prototype.slice.call(track.children);
    if (!baseSets.length) return;
    const speed = parseFloat(marquee.dataset.speed) || 60; // px per second
    // Some marquees should only scroll on mobile and stay static on desktop.
    const mobileOnly = marquee.hasAttribute("data-marquee-mobile-only");
    const MOBILE_BP = 900;

    // Clones are decorative duplicates — keep them out of the accessibility tree.
    function cloneSet(index) {
      const clone = baseSets[index % baseSets.length].cloneNode(true);
      clone.setAttribute("aria-hidden", "true");
      // Clones sit outside the clipped marquee before the animation moves them,
      // so lazy images in them never load (Safari) and leave blank gaps.
      Array.prototype.forEach.call(clone.querySelectorAll("img"), function (img) {
        img.loading = "eager";
      });
      return clone;
    }

    function build() {
      if (!marquee.isConnected) return; // section was re-rendered; stale node
      track.style.animation = "none"; // freeze while measuring
      while (track.children.length > baseSets.length) {
        track.removeChild(track.lastElementChild);
      }
      if (reduce) return; // leave one static copy
      if (mobileOnly && window.innerWidth > MOBILE_BP) return; // static on desktop

      const viewport =
        marquee.clientWidth || marquee.getBoundingClientRect().width;

      // Grow one half until it spans the viewport.
      let guard = 0;
      while (track.scrollWidth < viewport && guard < 60) {
        track.appendChild(cloneSet(track.children.length));
        guard++;
      }

      const halfCount = track.children.length;
      const halfWidth = track.scrollWidth;

      // Duplicate the half for the seamless -50% wrap.
      for (let i = 0; i < halfCount; i++) {
        track.appendChild(cloneSet(i));
      }

      track.style.setProperty(
        "--marquee-duration",
        Math.max(8, halfWidth / speed) + "s",
      );
      track.style.animation = ""; // hand back to the CSS rule
    }

    build();

    // Logos without a fixed CSS width (e.g. retailers) only get their final
    // width once the images decode. Re-measure after they load and per-image so
    // the half-width is exact and the -50% loop is seamless.
    window.addEventListener("load", build);
    Array.prototype.forEach.call(track.querySelectorAll("img"), function (img) {
      if (!img.complete) img.addEventListener("load", build, { once: true });
    });

    // Mobile browsers fire `resize` on scroll (the address bar shows/hides,
    // changing only the height). The marquee depends on width alone, so rebuild
    // only when the width actually changes — otherwise build() restarts the
    // animation and the marquee visibly jumps back to the start while scrolling.
    let lastWidth = window.innerWidth;
    let resizeTimer;
    window.addEventListener("resize", function () {
      if (window.innerWidth === lastWidth) return;
      lastWidth = window.innerWidth;
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(build, 200);
    });
  }

  // The theme editor and the CLI dev server re-render a section's HTML in
  // place, which drops the cloned sets. Re-initialise any marquee that appears
  // inside a freshly loaded section; already-built ones are skipped.
  function initAll(root) {
    const marquees = (root || document).querySelectorAll(
      ".js-marquee:not([data-marquee-ready])",
    );
    marquees.forEach(function (marquee) {
      marquee.setAttribute("data-marquee-ready", "");
      initMarquee(marquee);
    });
  }

  initAll();
  document.addEventListener("shopify:section:load", function (event) {
    initAll(event.target);
  });
  // The CLI dev server swaps the section's outerHTML without firing the editor
  // event, so also watch for freshly inserted marquees.
  if ("MutationObserver" in window) {
    new MutationObserver(function (mutations) {
      for (let i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes.length) {
          initAll();
          return;
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
})();

// Shop-the-routine slider: the track holds the routine cards in one row. Drag it
// with a mouse or finger to page through them (the track follows the pointer,
// then snaps to the nearest page on release); clicking a dot jumps straight
// there. The page size is responsive — three cards per page on desktop, one per
// page on mobile (matching the CSS breakpoint) — and the dots are rebuilt to
// match, so the same code drives both layouts.
(function () {
  const track = document.querySelector("[data-routine-track]");
  if (!track) return;
  const dotsWrap = document.querySelector("[data-routine-dots]");
  const realCards = Array.prototype.slice.call(track.children);
  if (!dotsWrap || realCards.length < 2) return;

  const COMMIT = 40; // px dragged before snapping to the next/prev page
  const AXIS_SLOP = 6; // px before deciding the drag is horizontal vs vertical
  const AUTOPLAY_MS = 10000; // advance one page (perPage cards) every 10s
  const SNAP_MS = 500; // glide for manual drag/dot navigation
  const GLIDE_MS = 1000; // slower, softer glide for the auto-advance
  // Keep in sync with the 880px routine breakpoint in style.css.
  const mobileQuery = window.matchMedia("(max-width: 880px)");
  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

  let index = 0; // real page index, 0..pageCount-1
  let perPage = 1;
  let pageCount = 1;
  let allCards = realCards; // includes lead/trail clones after build
  let realStart = 0; // index of the first real card inside allCards
  let dots = [];
  let dragging = false;
  let pointerId = null;
  let startX = 0;
  let startY = 0;
  let dragDX = 0;
  let axis = null; // 'x' (horizontal drag) | 'y' (let the page scroll) | null
  let moved = false; // a real drag happened — used to swallow the trailing click
  let pendingReset = null; // realIndex to snap to silently after a wrap animation
  let resetTimer = null; // fallback when transitionend never fires (reduced motion)
  let autoplayTimer = null;
  let hovering = false;

  function buildDots() {
    dotsWrap.innerHTML = "";
    dots = [];
    for (let i = 0; i < pageCount; i++) {
      const dot = document.createElement("button");
      dot.type = "button";
      dot.className = "routine__dot";
      dot.setAttribute("aria-label", "View routine " + (i + 1));
      const di = i;
      dot.addEventListener("click", function () {
        goWrapped(di, SNAP_MS);
      });
      dotsWrap.appendChild(dot);
      dots.push(dot);
    }
  }

  // Clone `perPage` cards onto each end so dragging past the first/last page
  // lands on a duplicate that we silently swap back to its real twin — the
  // Slick "infinite" trick. Rebuilt whenever perPage changes.
  function buildClones() {
    track
      .querySelectorAll("[data-clone]")
      .forEach(function (c) {
        track.removeChild(c);
      });
    const lead = document.createDocumentFragment();
    const trail = document.createDocumentFragment();
    for (let i = 0; i < perPage; i++) {
      const leadCard = realCards[realCards.length - perPage + i].cloneNode(true);
      leadCard.setAttribute("data-clone", "");
      leadCard.setAttribute("aria-hidden", "true");
      leadCard.inert = true;
      lead.appendChild(leadCard);
      const trailCard = realCards[i].cloneNode(true);
      trailCard.setAttribute("data-clone", "");
      trailCard.setAttribute("aria-hidden", "true");
      trailCard.inert = true;
      trail.appendChild(trailCard);
    }
    track.insertBefore(lead, track.firstChild);
    track.appendChild(trail);
    allCards = Array.prototype.slice.call(track.children);
    realStart = perPage;
  }

  function measure() {
    const nextPerPage = mobileQuery.matches ? 1 : 3;
    if (nextPerPage !== perPage || allCards === realCards) {
      perPage = nextPerPage;
      pageCount = Math.ceil(realCards.length / perPage);
      buildClones();
      buildDots();
    }
    index = Math.min(index, pageCount - 1);
  }

  // Visual position (in px) for a page slot; v may be -1 (lead) or pageCount
  // (trail) to address the clone pages.
  function offsetFor(v) {
    return -allCards[realStart + v * perPage].offsetLeft;
  }

  // ms > 0 animates over that duration; 0 (or reduced motion) jumps instantly.
  function setX(px, ms) {
    track.style.transition =
      ms && !reduceMotion.matches ? "transform " + ms + "ms var(--scene-ease)" : "none";
    track.style.transform = "translateX(" + px + "px)";
  }

  function updateDots() {
    dots.forEach(function (dot, di) {
      const active = di === index;
      dot.classList.toggle("is-active", active);
      dot.setAttribute("aria-current", active ? "true" : "false");
    });
  }

  // Move to a target slot that may be one page past either end. In-range goes
  // straight there; out-of-range animates onto the clone, then transitionend
  // jumps silently to the matching real page.
  function clearReset() {
    pendingReset = null;
    if (resetTimer) {
      clearTimeout(resetTimer);
      resetTimer = null;
    }
  }

  function finalizeReset() {
    if (pendingReset === null) return;
    setX(offsetFor(pendingReset), 0);
    clearReset();
  }

  function goWrapped(target, ms) {
    clearReset();
    if (target >= 0 && target < pageCount) {
      index = target;
      setX(offsetFor(index), ms);
      updateDots();
      scheduleAutoplay();
      return;
    }
    const realIndex = target < 0 ? pageCount - 1 : 0;
    pendingReset = realIndex;
    setX(offsetFor(target), ms);
    index = realIndex;
    updateDots();
    // Safety net: if transitionend doesn't fire (e.g. reduced-motion disables
    // the transition), snap back to the real page anyway.
    resetTimer = setTimeout(finalizeReset, ms + 60);
    scheduleAutoplay();
  }

  function stopAutoplay() {
    if (autoplayTimer) {
      clearTimeout(autoplayTimer);
      autoplayTimer = null;
    }
  }

  // Re-arm the auto-advance unless paused (dragging, hovering, tab hidden) or
  // disabled (reduced motion, nothing to scroll). Called after every move so
  // manual interaction also resets the 10s countdown.
  function scheduleAutoplay() {
    stopAutoplay();
    if (
      reduceMotion.matches ||
      pageCount <= 1 ||
      dragging ||
      hovering ||
      document.hidden
    ) {
      return;
    }
    autoplayTimer = setTimeout(function () {
      goWrapped(index + 1, GLIDE_MS);
    }, AUTOPLAY_MS);
  }

  function onTransitionEnd(e) {
    if (e.target !== track || e.propertyName !== "transform") return;
    finalizeReset();
  }

  function onPointerDown(e) {
    if (e.pointerType === "mouse" && e.button !== 0) return; // left button only
    measure();
    // If a wrap-reset is still pending, snap to the canonical page first so the
    // drag starts from the real position rather than a clone.
    finalizeReset();
    stopAutoplay();
    dragging = true;
    pointerId = e.pointerId;
    startX = e.clientX;
    startY = e.clientY;
    dragDX = 0;
    axis = null;
    moved = false;
  }

  function onPointerMove(e) {
    if (!dragging || e.pointerId !== pointerId) return;
    const dx = e.clientX - startX;
    const dy = e.clientY - startY;

    if (axis === null) {
      if (Math.abs(dx) < AXIS_SLOP && Math.abs(dy) < AXIS_SLOP) return;
      axis = Math.abs(dx) > Math.abs(dy) ? "x" : "y";
      if (axis === "x") {
        track.classList.add("is-grabbing");
        if (track.setPointerCapture) track.setPointerCapture(pointerId);
      }
    }
    if (axis !== "x") return; // vertical intent — leave the page free to scroll

    e.preventDefault();
    moved = true;
    dragDX = dx;
    // Follow the pointer freely — the clones absorb any overscroll past the ends.
    setX(offsetFor(index) + dx, 0);
  }

  function onPointerUp(e) {
    if (!dragging || e.pointerId !== pointerId) return;
    dragging = false;
    track.classList.remove("is-grabbing");
    pointerId = null;

    let target = index;
    if (axis === "x") {
      if (dragDX <= -COMMIT) target = index + 1;
      else if (dragDX >= COMMIT) target = index - 1;
    }
    axis = null;
    goWrapped(target, SNAP_MS);
  }

  track.addEventListener("pointerdown", onPointerDown);
  window.addEventListener("pointermove", onPointerMove, { passive: false });
  window.addEventListener("pointerup", onPointerUp);
  window.addEventListener("pointercancel", onPointerUp);
  track.addEventListener("transitionend", onTransitionEnd);

  // Swallow the click that fires right after a drag so buttons/links inside the
  // cards don't activate when the user was only dragging.
  track.addEventListener(
    "click",
    function (e) {
      if (moved) {
        e.preventDefault();
        e.stopPropagation();
        moved = false;
      }
    },
    true,
  );

  // Native image/link dragging would fight the pointer drag — disable it.
  track.addEventListener("dragstart", function (e) {
    e.preventDefault();
  });

  // Pause auto-advance while the pointer rests over the slider, resume on leave.
  const viewport = track.parentElement;
  viewport.addEventListener("pointerenter", function (e) {
    if (e.pointerType === "touch") return; // touch has no lingering hover
    hovering = true;
    stopAutoplay();
  });
  viewport.addEventListener("pointerleave", function (e) {
    if (e.pointerType === "touch") return;
    hovering = false;
    scheduleAutoplay();
  });
  document.addEventListener("visibilitychange", scheduleAutoplay);

  window.addEventListener("resize", function () {
    measure();
    setX(offsetFor(index), 0);
  });

  measure();
  setX(offsetFor(0), 0);
  updateDots();
  scheduleAutoplay();
})();

// "One routine, three moments of support": hero-style auto-slide. The hexagon
// cards step through one whole position on a timer (next peeks in from the
// upper-left, previous drops out below) while the copy on the right cross-fades
// in sync. It ping-pongs (0->N-1->0) so every transition is a single-position
// slide with no jump. Autoplay only runs while the section is on screen and the
// tab is visible, and pauses on hover.
(function () {
  const section = document.querySelector(".moments");
  const scene = section && section.querySelector("[data-moments-scene]");
  if (!scene) return;
  const cards = Array.prototype.slice.call(
    scene.querySelectorAll(".moments__card"),
  );
  const stepsWrap = section.querySelector("[data-moments-steps]");
  const steps = stepsWrap
    ? Array.prototype.slice.call(stepsWrap.querySelectorAll(".moments__step"))
    : [];
  const dotsWrap = section.querySelector("[data-moments-dots]");
  let dots = [];
  const N = cards.length;
  if (N < 2) return;

  const navEl = document.querySelector(".site-nav");
  const STEP_Y_MAX = 215; // desired vertical offset per card step

  // Symmetric vertical gap between cards, capped so the neighbours clear both the
  // nav (top) and the section's bottom edge — keeps the whole stack centred in the
  // visible area below the nav, with equal room above and below.
  function stepY() {
    const cardH = cards[0] ? cards[0].offsetHeight : 568; // unscaled layout height
    const neighbourHalf = (cardH * (1 - SCALE_DROP)) / 2; // scaled half-height
    const margin = 14;
    const navH = navEl ? navEl.offsetHeight : 106;
    // Use the pinned (centred) scene position, which is fixed, rather than the
    // live scroll position — so the cards sit correctly even before the section
    // locks, instead of being bunched up at the centre until scrolling starts.
    const centerY = (window.innerHeight + navH) / 2;
    const roomDown = window.innerHeight - margin - centerY - neighbourHalf;
    const roomUp = centerY - navH - margin - neighbourHalf;
    return Math.max(60, Math.min(STEP_Y_MAX, roomDown, roomUp));
  }
  const OFF_X = 190; // px each neighbour is nudged left (further out as they fade)
  const ACTIVE_X = 50; // px the centred (active) card is pushed right
  const SCALE_DROP = 0.32; // scale lost per step away from centre (smaller neighbours)
  const OPACITY_DROP = 0.72; // opacity lost per step away from centre
  const DUR = 700; // step animation (matches the CSS transition)
  const AUTOPLAY_MS = 4000; // each scene rests this long before advancing
  // Mobile: a smaller single-column stage. The active card stays centred while the
  // others slide off to the left (and up/down) like desktop, clipped by the stage.
  const MOBILE_STEP_Y = 84;
  const MOBILE_OFF_X = 130; // px each neighbour is nudged left as it fades out

  const reduceMotion = window.matchMedia(
    "(prefers-reduced-motion: reduce)",
  ).matches;
  const isMobile = window.matchMedia("(max-width: 900px)").matches;
  // On laptops the neighbours read a touch large — shrink the inactive cards a bit.
  const laptop = window.matchMedia("(min-width: 1025px) and (max-width: 1600px)");
  const LAPTOP_NEIGHBOUR_SCALE = 0.85;

  let step = 0;
  let dir = 1; // ping-pong direction: +1 forward, -1 back
  let animating = false;

  function place(animate) {
    cards.forEach(function (card, i) {
      const d = i - step;
      const ad = Math.abs(d);
      // Symmetric gap so the neighbours sit evenly above and below the active.
      const y = -d * (isMobile ? MOBILE_STEP_Y : stepY());
      // Active stays centred; neighbours slide left as they fade. Desktop also
      // nudges the active card right; mobile keeps it dead-centre.
      const x = isMobile
        ? -ad * MOBILE_OFF_X
        : (1 - Math.min(ad, 1)) * ACTIVE_X - ad * OFF_X;
      let s = Math.max(0.62, 1 - ad * SCALE_DROP);
      if (ad > 0 && laptop.matches) s *= LAPTOP_NEIGHBOUR_SCALE;
      const o = Math.max(0, 1 - ad * OPACITY_DROP);
      card.style.transition = animate === false ? "none" : "";
      card.style.transform =
        "translate(calc(-50% + " +
        x +
        "px), calc(-50% + " +
        y +
        "px)) scale(" +
        s +
        ")";
      card.style.opacity = o;
      card.style.zIndex = String(Math.round(100 - ad * 10));
    });

    // Copy blocks slide within their clip-box in sync: future steps parked above,
    // past steps parked below, the active one centred (hero-style).
    steps.forEach(function (block, i) {
      const d = i - step;
      const active = d === 0;
      block.style.transition = animate === false ? "none" : "";
      block.style.transform = active
        ? "translateY(0)"
        : "translateY(" + (d > 0 ? -100 : 100) + "%)";
      block.style.opacity = active ? "1" : "0";
      block.classList.toggle("is-active", active);
      block.setAttribute("aria-hidden", active ? "false" : "true");
    });

    updateDots();
    syncStepsHeight();
  }

  function buildDots() {
    if (!dotsWrap) return;
    dotsWrap.innerHTML = "";
    dots = [];
    for (let i = 0; i < N; i++) {
      const dot = document.createElement("button");
      dot.type = "button";
      dot.className = "moments__dot";
      dot.setAttribute("aria-label", "Moment " + (i + 1));
      const di = i;
      dot.addEventListener("click", function () {
        goTo(di);
      });
      dotsWrap.appendChild(dot);
      dots.push(dot);
    }
  }

  function updateDots() {
    dots.forEach(function (dot, di) {
      const active = di === step;
      dot.classList.toggle("is-active", active);
      dot.setAttribute("aria-current", active ? "true" : "false");
    });
  }

  // Let the copy clip-box hug the active step so shorter steps don't leave a gap
  // below the text (the box would otherwise stay as tall as the longest step).
  function syncStepsHeight() {
    if (stepsWrap && steps[step]) {
      stepsWrap.style.height = steps[step].offsetHeight + "px";
    }
  }

  // Advance one whole position, bouncing off either end so the direction flips
  // instead of jumping (0->1->..->N-1->N-2->..->0->1..).
  function advance() {
    if (animating) return;
    if (step + dir > N - 1 || step + dir < 0) dir = -dir;
    step += dir;
    animating = true;
    place(true);
    window.setTimeout(function () {
      animating = false;
    }, DUR);
  }

  // Jump to a chosen scene (dot click). The ping-pong direction picks up from the
  // new position so autoplay keeps stepping toward whichever end is further.
  function goTo(target) {
    if (animating || target === step) return;
    dir = target > step ? 1 : -1;
    step = target;
    animating = true;
    place(true);
    window.setTimeout(function () {
      animating = false;
    }, DUR);
    scheduleAutoplay(); // restart the countdown after a manual pick
  }

  let autoplayTimer = null;
  let onScreen = false;

  function stopAutoplay() {
    if (autoplayTimer) {
      clearTimeout(autoplayTimer);
      autoplayTimer = null;
    }
  }

  // Re-arm the auto-advance unless paused (off screen or tab hidden).
  function scheduleAutoplay() {
    stopAutoplay();
    if (!onScreen || document.hidden) return;
    autoplayTimer = window.setTimeout(function () {
      advance();
      scheduleAutoplay();
    }, AUTOPLAY_MS);
  }

  if (reduceMotion) {
    // Reduced-motion: no autoplay — show the cards stacked in flow (CSS handles it).
    section.classList.add("moments--static");
    return;
  }

  buildDots();

  // Prev/next arrows step one moment (wrapping around the ends), reusing goTo so
  // the ping-pong direction and the autoplay restart stay consistent with dots.
  section.querySelectorAll("[data-moments-nav-btn]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      const delta = btn.getAttribute("data-moments-nav-btn") === "prev" ? -1 : 1;
      goTo((((step + delta) % N) + N) % N);
    });
  });

  place(false); // initial state (first card centred)

  // Only run while the section is actually on screen.
  if ("IntersectionObserver" in window) {
    new IntersectionObserver(
      function (entries) {
        onScreen = entries[0].isIntersecting;
        scheduleAutoplay();
      },
      { threshold: 0.35 },
    ).observe(section);
  } else {
    onScreen = true;
    scheduleAutoplay();
  }

  document.addEventListener("visibilitychange", scheduleAutoplay);

  // Re-render when crossing the laptop breakpoint so the neighbour scale updates.
  laptop.addEventListener("change", function () {
    place(false);
  });
  // Re-measure the active step when the viewport (and thus title wrapping) changes.
  window.addEventListener("resize", syncStepsHeight);
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(syncStepsHeight);
  }
})();

// Social-proof row ("500,000+ People Who Chose Their Mornings"): the shape + the
// card track form one rail, shifted horizontally by JS in step with scroll (same
// idea as the retailers strip). As the section rises into view the rail slides in
// from the right until the card track fills 100% of the container and the
// product-stack shape is pushed out into the left gutter. Not a slider.
(function () {
  const section = document.getElementById("voicesReviews");
  if (!section) return;
  const rail = section.querySelector(".voices__rail");
  const track = section.querySelector(".sp-track");
  const shape = section.querySelector(".voices__shape");
  if (!rail || !track) return;

  const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  // Below this width the rail becomes a CSS swipe carousel; JS stops driving it.
  const mobile = window.matchMedia("(max-width: 560px)");

  // The nav bar is the centred 1200px container; its left offset is the gutter.
  const navBar = document.querySelector(".site-nav__bar");
  function gutter() {
    if (navBar) {
      const rect = navBar.getBoundingClientRect();
      const pad = parseFloat(getComputedStyle(navBar).paddingLeft) || 0;
      return rect.left + pad;
    }
    const cw = Math.min(1200, window.innerWidth - 48);
    return (window.innerWidth - cw) / 2;
  }

  function railGap() {
    return parseFloat(getComputedStyle(rail).columnGap) || 16;
  }

  let restX = 0; // progress 0 — rail shifted right, ready to slide in
  let endX = 0; // progress 1 — track fills the container, shape pushed left
  let ticking = false;

  function measure() {
    // On phones the rail is a CSS swipe carousel — drop any inline sizing/offset
    // so the stylesheet fully owns the layout.
    if (mobile.matches) {
      track.style.width = "";
      rail.style.transform = "";
      return;
    }
    const g = gutter();
    // Track fills the container exactly.
    track.style.width = window.innerWidth - g * 2 + "px";
    const shapeW = shape ? shape.offsetWidth : 0;
    const gap = shapeW ? railGap() : 0;
    // Settled: shift the rail left so the track's left edge lands at the
    // container's left edge; the leading shape is pushed into the left gutter.
    endX = g - shapeW - gap;
    // At rest the rail sits further right and slides left into place on scroll.
    const reveal = Math.min(2000, window.innerWidth * 0.8);
    restX = endX + reveal;
  }

  function progress() {
    const rect = section.getBoundingClientRect();
    const vh = window.innerHeight;
    const start = vh; // 0 when the section's top is at the viewport bottom
    const end = vh * 0.4; // 1 once it has risen to ~40% from the top
    return Math.min(1, Math.max(0, (start - rect.top) / (start - end)));
  }

  function render() {
    ticking = false;
    if (mobile.matches) return; // carousel mode: CSS owns the layout
    const x = reduce ? endX : restX + (endX - restX) * progress();
    rail.style.transform = "translateX(" + x + "px)";
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(render);
  }

  function onResize() {
    measure();
    onScroll();
  }

  measure();
  render();
  window.addEventListener("scroll", onScroll, { passive: true });
  window.addEventListener("resize", onResize, { passive: true });
  // Re-measure once the shape image has its intrinsic width.
  window.addEventListener("load", function () {
    measure();
    render();
  });
})();

// (Mobile hamburger + nav accordions are handled globally by ndw-v2-header.js;
// the duplicate handlers that lived here caused a double-toggle on the home page.)

// "Backed by people who know best" expert cards: a static 3-up row on desktop,
// and a one-card-per-screen swipe slider with dots on mobile (same page-based
// mechanic as the routine slider). Dots are hidden by CSS above 880px.
(function () {
  const track = document.querySelector("[data-experts-track]");
  if (!track) return;
  const dotsWrap = document.querySelector("[data-experts-dots]");
  const realCards = Array.prototype.slice.call(track.children);
  if (!dotsWrap || realCards.length < 2) return;

  const COMMIT = 40; // px dragged before snapping to the next/prev page
  const AXIS_SLOP = 6; // px before deciding the drag is horizontal vs vertical
  // Keep in sync with the 880px experts breakpoint in style.css.
  const mobileQuery = window.matchMedia("(max-width: 880px)");

  let index = 0; // active page index, 0..pageCount-1
  let perPage = 1;
  let pageCount = 1;
  let allCards = realCards; // includes lead/trail clones when loopable
  let realStart = 0; // index of the first real card inside allCards
  let loopable = false;
  let dots = [];
  let dragging = false;
  let pointerId = null;
  let startX = 0;
  let startY = 0;
  let dragDX = 0;
  let axis = null;
  let moved = false;
  let pendingReset = null; // page to snap to silently after a wrap animation
  let resetTimer = null;

  function buildDots() {
    dotsWrap.innerHTML = "";
    dots = [];
    if (!loopable) return;
    for (let i = 0; i < pageCount; i++) {
      const dot = document.createElement("button");
      dot.type = "button";
      dot.className = "experts__dot";
      dot.setAttribute("aria-label", "View expert " + (i + 1));
      const di = i;
      dot.addEventListener("click", function () {
        go(di, true);
      });
      dotsWrap.appendChild(dot);
      dots.push(dot);
    }
  }

  // First real card index a page starts on. -1 / pageCount address the lead /
  // trail clone pages; the last page aligns to the end so a non-divisible card
  // count never leaves clones dangling mid-view.
  function pageStartCard(v) {
    if (v <= -1) return -perPage;
    if (v >= pageCount) return realCards.length;
    if (v === pageCount - 1) return Math.max(0, realCards.length - perPage);
    return v * perPage;
  }
  function cardLeft(k) {
    return allCards[k].offsetLeft;
  }
  function offsetFor(v) {
    return -(cardLeft(realStart + pageStartCard(v)) - cardLeft(0));
  }
  function step() {
    if (allCards.length < 2) return track.parentElement.clientWidth;
    return cardLeft(1) - cardLeft(0);
  }

  function setX(px, animate) {
    track.style.transition = animate ? "" : "none";
    track.style.transform = "translateX(" + px + "px)";
  }
  function updateDots() {
    dots.forEach(function (dot, di) {
      const active = di === index;
      dot.classList.toggle("is-active", active);
      dot.setAttribute("aria-current", active ? "true" : "false");
    });
  }
  function clearReset() {
    pendingReset = null;
    if (resetTimer) {
      clearTimeout(resetTimer);
      resetTimer = null;
    }
  }
  function finalizeReset() {
    if (pendingReset === null) return;
    setX(offsetFor(index), false);
    clearReset();
  }
  function go(target, animate) {
    clearReset();
    if (!loopable) {
      index = 0;
      setX(offsetFor(0), false);
      return;
    }
    if (target >= 0 && target < pageCount) {
      index = target;
      setX(offsetFor(index), animate);
      updateDots();
      return;
    }
    index = target < 0 ? pageCount - 1 : 0;
    pendingReset = index;
    setX(offsetFor(target), animate);
    updateDots();
    // Safety net for when transitionend doesn't fire (reduced motion).
    resetTimer = setTimeout(finalizeReset, 560);
  }

  // (Re)build clones + dots for the current breakpoint. Called on init and on
  // resize, since the desktop/mobile switch changes perPage and the clone count.
  function setup() {
    track.querySelectorAll("[data-clone]").forEach((c) => track.removeChild(c));
    perPage = mobileQuery.matches ? 1 : 3;
    pageCount = Math.ceil(realCards.length / perPage);
    loopable = pageCount > 1;
    if (!loopable) {
      allCards = realCards;
      realStart = 0;
      index = 0;
      buildDots();
      setX(offsetFor(0), false);
      return;
    }
    const lead = document.createDocumentFragment();
    const trail = document.createDocumentFragment();
    for (let i = 0; i < perPage; i++) {
      const leadCard = realCards[realCards.length - perPage + i].cloneNode(true);
      leadCard.setAttribute("data-clone", "");
      leadCard.setAttribute("aria-hidden", "true");
      leadCard.inert = true;
      lead.appendChild(leadCard);
      const trailCard = realCards[i].cloneNode(true);
      trailCard.setAttribute("data-clone", "");
      trailCard.setAttribute("aria-hidden", "true");
      trailCard.inert = true;
      trail.appendChild(trailCard);
    }
    track.insertBefore(lead, track.firstChild);
    track.appendChild(trail);
    allCards = Array.prototype.slice.call(track.children);
    realStart = perPage;
    index = Math.min(index, pageCount - 1);
    buildDots();
    updateDots();
    setX(offsetFor(index), false);
  }

  function onPointerDown(e) {
    if (e.pointerType === "mouse" && e.button !== 0) return;
    if (!loopable) return; // nothing to page through (desktop 3-up)
    finalizeReset();
    dragging = true;
    pointerId = e.pointerId;
    startX = e.clientX;
    startY = e.clientY;
    dragDX = 0;
    axis = null;
    moved = false;
  }

  function onPointerMove(e) {
    if (!dragging || e.pointerId !== pointerId) return;
    const dx = e.clientX - startX;
    const dy = e.clientY - startY;

    if (axis === null) {
      if (Math.abs(dx) < AXIS_SLOP && Math.abs(dy) < AXIS_SLOP) return;
      axis = Math.abs(dx) > Math.abs(dy) ? "x" : "y";
      if (axis === "x") {
        track.classList.add("is-grabbing");
        if (track.setPointerCapture) track.setPointerCapture(pointerId);
      }
    }
    if (axis !== "x") return;

    e.preventDefault();
    moved = true;
    dragDX = dx;
    // Follow the pointer freely — the clones absorb any overscroll past the ends.
    setX(offsetFor(index) + dx, false);
  }

  function onPointerUp(e) {
    if (!dragging || e.pointerId !== pointerId) return;
    dragging = false;
    track.classList.remove("is-grabbing");
    pointerId = null;

    let target = index;
    if (axis === "x") {
      if (dragDX <= -COMMIT) target = index + 1;
      else if (dragDX >= COMMIT) target = index - 1;
    }
    axis = null;
    go(target, true);
  }

  track.addEventListener("pointerdown", onPointerDown);
  window.addEventListener("pointermove", onPointerMove, { passive: false });
  window.addEventListener("pointerup", onPointerUp);
  window.addEventListener("pointercancel", onPointerUp);
  track.addEventListener("transitionend", function (e) {
    if (e.target === track && e.propertyName === "transform") finalizeReset();
  });

  track.addEventListener(
    "click",
    function (e) {
      if (moved) {
        e.preventDefault();
        e.stopPropagation();
        moved = false;
      }
    },
    true,
  );

  track.addEventListener("dragstart", function (e) {
    e.preventDefault();
  });

  let rt;
  window.addEventListener("resize", function () {
    clearTimeout(rt);
    rt = setTimeout(setup, 150);
  });

  setup();
})();

// Footer currency selector: a small dropdown (USD / CAD / GBP) that updates the
// displayed code + symbol. Opens upward; closes on outside click or Escape.
(function () {
  const wrap = document.querySelector("[data-currency]");
  if (!wrap) return;
  const toggle = wrap.querySelector(".footer__currency");
  const codeEl = wrap.querySelector(".footer__currency-code");
  const symEl = wrap.querySelector(".footer__currency-sym");
  const options = Array.prototype.slice.call(
    wrap.querySelectorAll(".footer__currency-opt"),
  );
  if (!toggle || !codeEl || !symEl) return;

  function open() {
    wrap.classList.add("is-open");
    toggle.setAttribute("aria-expanded", "true");
  }

  function close() {
    wrap.classList.remove("is-open");
    toggle.setAttribute("aria-expanded", "false");
  }

  toggle.addEventListener("click", function (e) {
    e.stopPropagation();
    if (wrap.classList.contains("is-open")) close();
    else open();
  });

  options.forEach(function (opt) {
    opt.addEventListener("click", function () {
      codeEl.textContent = opt.dataset.code;
      symEl.textContent = opt.dataset.sym;
      options.forEach(function (o) {
        const active = o === opt;
        o.classList.toggle("is-active", active);
        o.setAttribute("aria-selected", active ? "true" : "false");
      });
      close();
    });
  });

  document.addEventListener("click", function (e) {
    if (!wrap.contains(e.target)) close();
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") close();
  });
})();

}
